import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const getPoultryScienceForBazresi = createAsyncThunk(
  "GET_POULTRY_SCIENCE_FOR_BAZRESI",
  async () => {
    try {
      const { data, status } = await axios.get(
        "https://testbackend.rasadyar.com/poultry_science_for_bazresi/"
      );
      return { data, status };
    } catch (error) {
      console.error("Error fetching poultry science data:", error);
      throw error;
    }
  }
);
